import React from 'react';
import InnerPageBanner from '../../../components/InnerPageBanner';
import { Box, Container, Typography, Grid } from '@mui/material';

// Import all 28 paving stone images
import pavingstone1 from "../../../assets/images/Paving Stone1.jpeg";
import pavingstone2 from "../../../assets/images/Paving Stone2.jpeg";
import pavingstone3 from "../../../assets/images/Paving Stone3.jpeg";
import pavingstone4 from "../../../assets/images/Paving Stone4.jpeg";
import pavingstone5 from "../../../assets/images/Paving Stone5.jpeg";
import pavingstone6 from "../../../assets/images/Paving Stone6.jpeg";
import pavingstone7 from "../../../assets/images/Paving Stone7.jpeg";
import pavingstone8 from "../../../assets/images/Paving Stone8.jpeg";
import pavingstone9 from "../../../assets/images/Paving Stone9.jpeg";
import pavingstone10 from "../../../assets/images/Paving Stone10.jpeg";
import pavingstone11 from "../../../assets/images/Paving Stone11.jpeg";
import pavingstone12 from "../../../assets/images/Paving Stone12.jpeg";
import pavingstone13 from "../../../assets/images/Paving Stone13.jpeg";
import pavingstone14 from "../../../assets/images/Paving Stone14.jpeg";
import pavingstone15 from "../../../assets/images/Paving Stone15.jpeg";
import pavingstone16 from "../../../assets/images/Paving Stone16.jpeg";
import pavingstone17 from "../../../assets/images/Paving Stone17.jpeg";
import pavingstone18 from "../../../assets/images/Paving Stone18.jpeg";
import pavingstone19 from "../../../assets/images/Paving Stone19.jpeg";
import pavingstone20 from "../../../assets/images/Paving Stone20.jpeg";
import pavingstone21 from "../../../assets/images/Paving Stone21.jpeg";
import pavingstone22 from "../../../assets/images/Paving Stone22.jpeg";
import pavingstone23 from "../../../assets/images/Paving Stone23.jpeg";
import pavingstone24 from "../../../assets/images/Paving Stone24.jpeg";
import pavingstone25 from "../../../assets/images/Paving Stone25.jpeg";
import pavingstone26 from "../../../assets/images/Paving Stone26.jpeg";
import pavingstone27 from "../../../assets/images/Paving Stone27.jpeg";
import pavingstone28 from "../../../assets/images/Paving Stone28.jpeg";

// Create array of all images
const pavingStoneImages = [
    pavingstone1, pavingstone2, pavingstone3, pavingstone4,
    pavingstone5, pavingstone6, pavingstone7, pavingstone8,
    pavingstone9, pavingstone10, pavingstone11, pavingstone12,
    pavingstone13, pavingstone14, pavingstone15, pavingstone16,
    pavingstone17, pavingstone18, pavingstone19, pavingstone20,
    pavingstone21, pavingstone22, pavingstone23, pavingstone24,
    pavingstone25, pavingstone26, pavingstone27, pavingstone28
];

const PavingStone = () => {
    return (
        <Box>
            <InnerPageBanner title="Paving Stone" />
            <Container sx={{ py: 5 }}>
                <Box sx={{
                    backgroundColor: "#f5f5f5",
                    py: { xs: 4, md: 6 },
                    px: { xs: 2, md: 4 },
                    borderRadius: 2
                }}>
                    {/* ===== Top Hero Section ===== */}
                    <Box
                        sx={{
                            backgroundColor: "#eaeaea",
                            p: { xs: 3, sm: 5, md: 8 },
                            mb: { xs: 5, md: 8 },
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: "#777", mb: 2, fontSize: { xs: 12, md: 14 } }}
                        >
                            No Doubt We Are Trusted
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: 24, sm: 28, md: 36 }
                            }}
                        >
                            Paving Stone
                        </Typography>

                        <Box
                            sx={{
                                width: 50,
                                height: 3,
                                backgroundColor: "#1abc9c",
                                my: 2
                            }}
                        />

                        <Box sx={{ mt: 3 }}>
                            <Typography sx={{ fontSize: { xs: 13, md: 14 } }}>
                                <strong>Available Color</strong><br />
                                Grey (White)<br />
                                Jet Black<br />
                                Pink (Red)
                            </Typography>

                            <Typography sx={{ mt: 3, fontSize: { xs: 13, md: 14 } }}>
                                <strong>Available Sizes</strong><br />
                                1'x1' Feet 300×300mm 30×30cm<br />
                                1'x2' Feet 300×600mm 30×60cm<br />
                                1'x3' Feet 300×900mm 30×90cm<br />
                                2'x2' Feet 600×600mm 60×60cm<br />
                                2'x3' Feet 600×900mm 60×90cm<br />
                                2'x4' Feet 600×1200mm 60×120cm<br />
                                1.5'x1' Feet 450×300mm 45×30cm<br />
                                1.5'x2' Feet 450×600mm 45×60cm
                            </Typography>
                        </Box>
                    </Box>

                    {/* ===== Image Gallery Section ===== */}
                    <Typography
                        sx={{
                            fontWeight: 700,
                            mb: 3,
                            fontSize: { xs: 20, md: 24 }
                        }}
                    >
                        Paving Stone Varieties
                    </Typography>

                    <Box sx={{ width: 40, height: 3, backgroundColor: "#1abc9c", mb: 4 }} />

                    {/* Feature List */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 4 }}>
                            <Typography sx={{ color: "#555", display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box component="span" sx={{ color: '#1abc9c', fontSize: '20px' }}>•</Box>
                                Premium quality paving stones
                            </Typography>
                            <Typography sx={{ color: "#555", display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box component="span" sx={{ color: '#1abc9c', fontSize: '20px' }}>•</Box>
                                Available in multiple sizes and colors
                            </Typography>
                            <Typography sx={{ color: "#555", display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box component="span" sx={{ color: '#1abc9c', fontSize: '20px' }}>•</Box>
                                Durable and long-lasting material
                            </Typography>
                            <Typography sx={{ color: "#555", display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box component="span" sx={{ color: '#1abc9c', fontSize: '20px' }}>•</Box>
                                Perfect for driveways and walkways
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container spacing={4}>

                        {/* All 28 Images in Grid */}
                        {pavingStoneImages.map((image, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                                <Box
                                    component="img"
                                    src={image}
                                    alt={`Paving Stone ${index + 1}`}
                                    sx={{
                                        width: "100%",
                                        height: { xs: 200, sm: 220, md: 250 },
                                        objectFit: "cover",
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.02)',
                                            boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
                                        }
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default PavingStone;